import {DateTime} from "luxon";
import {useCallback, useState} from "react";
import { Button, DatePicker, Modal, LegacyStack, Text } from "@shopify/polaris";

export function formatDateToUsFormat(dateString)
{
    return DateTime
        .fromISO(dateString, {
            zone: window.shopifyTimeZone,
        })
        .setLocale('en-US')
        .toLocaleString({
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZoneName: 'short',
        });
}

export function toDate(input, timezone = true)
{
    if (!input) {
        return '';
    }

    const date = typeof input === 'string'
        ? DateTime.fromJSDate(new Date(input))
        : DateTime.fromJSDate(input);

    if (timezone) {
        return date
            .setLocale('en-US')
            .toLocaleString(DateTime.DATE_SHORT);
    }

    return date
        .setLocale('en-US')
        .toLocaleString(DateTime.DATE_SHORT);
}

export function formatDate(dateString)
{
    return DateTime.fromJSDate(new Date(dateString)).toISODate();
}
